import React, { Component } from "react";
import Admins from "../../components/admins/Admins";

class AdminsContainer extends Component {
  state = {
    admins: [],
    adminsByKey: {},
    adminsLoaded: false,
  };

  UNSAFE_componentWillMount = () => {
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    this.unsubscribe = tournamentRef
      .collection("admins")
      .onSnapshot((querySnapshot) => {
        let admins = [];
        let adminsByKey = {};
        querySnapshot.forEach(function (doc) {
          let admin = doc.data();
          admin["id"] = doc.id;
          admins.push(admin);
          adminsByKey[doc.id] = admin;
        });

        this.setState({
          admins: admins,
          adminsByKey: adminsByKey,
          adminsLoaded: true,
        });
      });
  };

  componentWillUnmount = () => {
    this.unsubscribe();
  };

  render() {
    return (
      <Admins tournament={this.props.tournament} admins={this.state.admins} />
    );
  }
}

export default AdminsContainer;
